module.exports = __webpack_public_path__ + "img/page_info_point.8fce726.svg";